module.exports = __webpack_public_path__ + "img/辛集乡.50d4b79d.png";